
import { createContext } from 'react';

const AnalyzerContext = createContext();

export default AnalyzerContext;
